import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setAccessControlRoleList,
    setLoading,
    setError,
    setPagination,
    resetAccessControlRoleList,
} from "../reducers/getAccessControlRoleReducer";

// role = "advisor" | "ls"
// type = "list" | "assigned" | "all_students"
const getAccessControlRole = (token: any, role: string, type: string, teacher_id?: string, sort?: string, grade?:string, search?:string, page?: number) => async (
    dispatch: Dispatch
) => {
    dispatch(setLoading(true));
    try {
        const params = new URLSearchParams({ role, type });
        if (teacher_id) params.append("teacher_id", teacher_id);
        if (sort)       params.append("sort", sort);
        if (grade)      params.append("grade", grade);
        if (search)     params.append("search", search);
        if (page)       params.append("page", String(page));
        const result = await api.get(
            `adminpage/access-control/role/?${params.toString()}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            }
        );

        if (result) {
            dispatch(setLoading(false));
            if (result.data?.status === 200) {
                dispatch(setAccessControlRoleList(result.data.data));
                dispatch(setPagination(result.data));
            } else {
                dispatch(setError(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        dispatch(setError(error.response?.data?.message ?? "Something Went Wrong!"));
    }
};

export { getAccessControlRole, resetAccessControlRoleList };